// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OfferDetail_summary-card__pbaGq {
  margin-top: 36px;
  margin-bottom: 24px;
}
.OfferDetail_summary-card__pbaGq .OfferDetail_total-price__j71a9 {
  font-size: 20px;
  font-weight: bold;
}
.OfferDetail_summary-card__pbaGq .OfferDetail_discount__5c05q {
  font-size: 12px;
  color: green;
  margin-top: 5px;
  margin-bottom: 5px;
}
.OfferDetail_summary-card__pbaGq .OfferDetail_description__E12el {
  font-size: 12px;
  margin-bottom: 10px;
}

.OfferDetail_product__jAqeg {
  margin-bottom: 24px;
}

.OfferDetail_right-wrapper__d5z56 {
  float: right;
}
.OfferDetail_right-wrapper__d5z56 .OfferDetail_data-wrapper__9\\+6gR {
  display: flex;
  justify-content: space-between;
}
.OfferDetail_right-wrapper__d5z56 .OfferDetail_total-wrapper__Olyz2 {
  font-size: 18px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/views/Offers/OfferDetail/OfferDetail.module.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AACA;EACI,gBAAA;EACA,mBAAA;AAAJ;AACI;EACI,eCDG;EDEH,iBCCD;ADAP;AACI;EACI,eAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AACR;AACI;EACI,eAAA;EACA,mBAAA;AACR;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;AACI;EACI,aAAA;EACA,8BAAA;AACR;AACI;EACI,eAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;AACR","sourcesContent":["@use \"styles/typography\";\n.summary-card {\n    margin-top: 36px;\n    margin-bottom: 24px;\n    .total-price {\n        font-size: typography.$header-s;\n        font-weight: typography.$bold;\n    }\n    .discount {\n        font-size: 12px;\n        color: green;\n        margin-top: 5px;\n        margin-bottom: 5px;\n    }\n    .description {\n        font-size: 12px;\n        margin-bottom: 10px;\n    }\n}\n\n.product {\n    margin-bottom: 24px;\n}\n\n.right-wrapper {\n    float: right;\n    .data-wrapper {\n        display: flex;\n        justify-content: space-between;\n    }\n    .total-wrapper {\n        font-size: 18px;\n        font-weight: bold;\n        display: flex;\n        justify-content: space-between;\n    }\n}","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"summary-card": `OfferDetail_summary-card__pbaGq`,
	"total-price": `OfferDetail_total-price__j71a9`,
	"discount": `OfferDetail_discount__5c05q`,
	"description": `OfferDetail_description__E12el`,
	"product": `OfferDetail_product__jAqeg`,
	"right-wrapper": `OfferDetail_right-wrapper__d5z56`,
	"data-wrapper": `OfferDetail_data-wrapper__9+6gR`,
	"total-wrapper": `OfferDetail_total-wrapper__Olyz2`
};
export default ___CSS_LOADER_EXPORT___;
